import { ColumnData } from 'common/components/SearchBar';
import { commonColumnProps, rightAlignHeaderStyle } from 'common/utils/columnUtilities';

export const columns: ColumnData[] = [
  {
    key: '_documentPoolName',
    name: 'Folder',
    fieldName: '_documentPoolName',
    minWidth: 90,
    maxWidth: 120,
    ...commonColumnProps,
  },
  {
    key: 'indexName',
    name: 'Name',
    fieldName: 'indexName',
    minWidth: 150,
    ...commonColumnProps,
  },
  {
    key: 'indexReferenceNumber',
    name: 'Number',
    fieldName: 'indexReferenceNumber',
    minWidth: 100,
    maxWidth: 100,
    ...commonColumnProps,
  },
  {
    key: 'indexTransactionDate',
    name: 'Date',
    fieldName: 'indexTransactionDate',
    minWidth: 100,
    maxWidth: 100,
    ...commonColumnProps,
  },
  {
    key: '_documentContents',
    name: 'Contents',
    fieldName: '_documentContents',
    minWidth: 150,
    ...commonColumnProps,
  },
  {
    key: 'view',
    name: '',
    fieldName: 'view',
    minWidth: 20,
    maxWidth: 20,
    ...commonColumnProps,
    isResizable: false,
  },

  {
    key: 'fileReference',
    name: 'Document',
    fieldName: 'fileReference',
    minWidth: 120,
    ...commonColumnProps,
  },
  {
    key: 'indexAmount',
    name: 'Total',
    fieldName: 'indexAmount',
    minWidth: 70,
    ...commonColumnProps,
    styles: rightAlignHeaderStyle,
  },
  {
    key: 'isoCode',
    name: 'Currency',
    fieldName: 'isoCode',
    minWidth: 70,
    ...commonColumnProps,
  },
  {
    key: 'available',
    name: 'Available',
    fieldName: 'available',
    minWidth: 70,
    ...commonColumnProps,
    styles: rightAlignHeaderStyle,
  },
  {
    key: 'used',
    name: 'Used',
    fieldName: 'used',
    minWidth: 70,
    ...commonColumnProps,
    styles: rightAlignHeaderStyle,
  },
  {
    key: 'Comment',
    name: 'Comments',
    fieldName: 'comment',
    minWidth: 70,
    ...commonColumnProps,
  },
  {
    key: '_uploadDate',
    name: 'Uploaded',
    fieldName: '_uploadDate',
    minWidth: 150,
    maxWidth: 150,
    ...commonColumnProps,
  },
];
